import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import Input from "../../../../core/Inputs/DefaultInput";
import Checkbox from "../../../../core/CheckBox";
import { Icon } from "@blueprintjs/core";
import style from "../../../style.module.css";
import Button from "../../../../core/Button";
import Title from "../Title";	
import {Link} from "react-router-dom";

export const JoinExistingAccount = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);


  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <div className={"formcontainer" + " " + style.container}>
      <Link to="/"><Title /></Link>
      <div className={style.wrapper}>
        <Card view="raised" className={"formstyle" + " " + style.card} >
          <Typography
            type={device === "mobile" ? "h6" : "h5"}
            colorStep={100}
            tagName="div"
            className={"formhead"}
            style={{ textAlign: "center" }}
          >
            Join or create account?
          </Typography>
          <Typography className={"formsubhead"}
            type={device === "mobile" ? "caption" : "body"}
            colorStep={50}
            tagName="div"
            large={device !== "mobile"}
            style={{ textAlign: "center" }}
          >Your organization has existing account. Would you like to join this account or create new one?
          </Typography>
          <Link to="/JoiningRequestExistingAccount">
          <Button className={"formsbutton"}
            type="default"
            view="filled"
            color="primary"
            text="Join existing account"
            fill={true}
            onClick={() => setOpen(true)}
          />
          </Link>
          
          <div className={style.no_account_wraper}>
            <div className={style.no_account_label}>
              <div className={style.no_account_line} />
              <Typography
                type="body"
                colorStep={50}
                tagName="div"
                small
                className={"noaccmsg" + " " + style.no_account_text}
              >
                Or
              </Typography>
              <div className={style.no_account_line} />
            </div>
          </div>
          <Link to="/TeamAccountSetUp">
          <Button className={"formsbutton mt20"}
            type="default"
            view="outlined"
            color="primary"
            text="Create a new one"
            fill={true}

            onClick={() => setOpen(true)}
          />
          </Link>
          
        </Card>
      </div >

    </div >
  );
};

export default JoinExistingAccount;
